/**
 * This sets defaults and handles maintaining our auth token/params
 * between http requests.
 */

import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);


const comment = Vue.resource('comments{/id}');


// example usage: #todo
// import subject from './resources/subject'
// subject.query({}).then((res) => {
//   console.log(res)
// }, (res) => {
//   console.log(res)
// })




export default comment;



// WEBPACK FOOTER //
// ./src/resources/comment.js